import { MdxDiv } from '@features/mdx/MdxDiv';
import { LanguageEnum } from '@project-types/LanguageEnum';
import { MdxPageArticleIds } from '@features/mdx/MdxPageArticleIds';



const articleIds: MdxPageArticleIds = {
	[LanguageEnum.CZ]: 'afea7fc6-4d53-4555-9e1e-0de34ca931f8',
	[LanguageEnum.SK]: 'afea7fc6-4d53-4555-9e1e-0de34ca931f8',
	default: 'afea7fc6-4d53-4555-9e1e-0de34ca931f8'
}


export const TextBox = () => {

	return (
		<MdxDiv className='text-box' articleIds={articleIds}>
		</MdxDiv>
	);
};